import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Channels from './pages/channels/Channels';
import Packages from './pages/packages/Packages';
import Ads from './pages/ads/Ads';
import Users from './pages/users/Users';
import Devices from './pages/devices/Devices';
import LiveViewers from './pages/live-viewers/LiveViewers';
import Subscriptions from './pages/subscriptions/Subscriptions';
import Wallet from './pages/wallet/Wallet';
import Network from './pages/network/Network';
import Subscribers from './pages/subscribers/Subscribers';
import Movies from './pages/movies/Movies';
import Settings from './pages/settings/Settings';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#0f1117' }}>
      <div className="spinner"></div>
    </div>
  );
  return user ? children : <Navigate to="/login" />;
};

const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="channels" element={<Channels />} />
        <Route path="packages" element={<Packages />} />
        <Route path="ads" element={<Ads />} />
        <Route path="users" element={<Users />} />
        <Route path="devices" element={<Devices />} />
        <Route path="live-viewers" element={<LiveViewers />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="wallet" element={<Wallet />} />
        <Route path="network" element={<Network />} />
        <Route path="subscribers" element={<Subscribers />} />
        <Route path="settings" element={<Settings />} />
        <Route path="movies" element={<Movies />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#1e2235',
              color: '#e2e8f0',
              border: '1px solid #2d3250',
              borderRadius: '10px',
            },
          }}
        />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
